import { useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";

import { LdoAuthContext } from "@nens/ldo/auth-v1";

type QueryKey =
  | ["bulk-exports", "list"]
  | ["bulk-exports", "detail"]
  | ["scenarios", "list"]
  | ["scenarios", "detail"]
  | ["scenarios", "review"];

export function useQueryKey(query: QueryKey) {
  const { tenantId } = useContext(LdoAuthContext);

  // For now this seems enough.
  return [tenantId, "ldo-api-v1", ...query];
}

export function useInvalidateCache(queryKey: QueryKey, extra?: (string | number)[]) {
  const keyPrefix = useQueryKey(queryKey);
  const queryClient = useQueryClient();

  return async () =>
    queryClient.invalidateQueries({
      queryKey: extra ? [...keyPrefix, ...extra] : keyPrefix,
      refetchInactive: true, // Otherwise lists on other pages aren't refreshed!
      refetchActive: true,
    });
}
